import { render, staticRenderFns } from "./BridgeApprovedRequiredStep.vue?vue&type=template&id=2c982e60&scoped=true"
import script from "./BridgeApprovedRequiredStep.vue?vue&type=script&lang=ts"
export * from "./BridgeApprovedRequiredStep.vue?vue&type=script&lang=ts"
import style0 from "./BridgeApprovedRequiredStep.vue?vue&type=style&index=0&id=2c982e60&prod&lang=scss"
import style1 from "./BridgeApprovedRequiredStep.vue?vue&type=style&index=1&id=2c982e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c982e60",
  null
  
)

export default component.exports